import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { BadgeIndianRupee, Search, X } from "lucide-react";
import { AppDispatch, RootState } from "../../../../../store";
import { getNovaReferralNetwork } from "../../../../../Redux/referral/slice";
import Pagenation from "../../../../../ecommerce/globalcomponents/pagenation/Pagenation";
import NovaLevelTeamTable from "./NovaLevelTeamTable";
import "../../referralCommisson/SalarFlowPage.css";

const NovalLevelTeam = () => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderNo = queryParams.get("orderNo") || "";
  const milestoneNo = parseInt(queryParams.get("milestoneNo") || "1");

  const { novaReferralNetwork } = useSelector(
    (state: RootState) => state.referral,
  );

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    if (orderNo) {
      dispatch(
        getNovaReferralNetwork({
          orderNo,
          page,
          limit,
          status: "ALL",
          sortOrder: "DESC",
          search: debouncedSearch || undefined,
        }),
      );
    }
  }, [dispatch, orderNo, page, limit, debouncedSearch]);

  const currentMilestone = novaReferralNetwork.data?.network?.milestones?.find(
    (m: any) => m.milestoneNo === milestoneNo,
  );

  const members = currentMilestone?.members || [];
  const filteredMembers = debouncedSearch
    ? members.filter(
        (m: any) =>
          m.memberName?.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
          m.partnerNetworkId
            ?.toLowerCase()
            .includes(debouncedSearch.toLowerCase()),
      )
    : members;

  return (
    <section className="ri-page">
      <div className="ri-shell">
        <header className="ri-page-header">
          <div className="ri-page-title">
            <span className="ri-title-icon">
              <BadgeIndianRupee size={25} />
            </span>
            <div>
              <span className="ri-eyebrow">NOVA LEVEL</span>
              <h1>
                Nova Level Incentives :{" "}
                {currentMilestone?.milestoneName || `Milestone - ${milestoneNo}`}
              </h1>
              <p>
                Partner network, referring partner and referral incentive
                details for this milestone.
              </p>
            </div>
          </div>

          <div className="ri-header-actions">
            <div className="ri-search ri-header-search">
              <Search size={19} />
              <input
                type="search"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
                placeholder="Search members..."
                aria-label="Search members"
              />
              {search && (
                <button
                  type="button"
                  onClick={() => setSearch("")}
                  aria-label="Clear search"
                >
                  <X size={16} />
                </button>
              )}
            </div>
          </div>
        </header>

        <div className="ri-toolbar">
          <select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1);
            }}
            aria-label="Entries per page"
          >
            {[10, 25, 50, 75, 100].map((val) => (
              <option value={val} key={val}>
                {val} Entries
              </option>
            ))}
          </select>
        </div>

        <NovaLevelTeamTable members={filteredMembers} />

        <Pagenation
          currentPage={page}
          totalPages={novaReferralNetwork.data?.pagination?.totalPages || 0}
          onPageChange={setPage}
        />
      </div>
    </section>
  );
};

export default NovalLevelTeam;
